import { useEffect } from 'react';

import {
  useShadowRoot,
  TechDocsAddonLocations,
  createTechDocsAddonExtension,
} from '@backstage/plugin-techdocs-react';
import { createPlugin } from '@backstage/core-plugin-api';

export const TechDocsTabTextSizeContent = () => {
  const shadowRoot = useShadowRoot();

  useEffect(() => {
    if (!shadowRoot) return undefined;

    // mkdocs-material renders content tabs with a small default font-size on
    // the tab labels. Bump it up so tab titles are as legible as body text.
    // Injected on the stable shadow root so it survives TechDocs re-rendering
    // the article content.
    const style = document.createElement('style');
    style.textContent = `
      .md-typeset .tabbed-labels > label {
        font-size: 0.9rem;
      }
    `;
    shadowRoot.appendChild(style);

    return () => {
      style.remove();
    };
  }, [shadowRoot]);

  return null;
};

const techDocsTabTextSizePlugin = createPlugin({
  id: 'techDocsTabTextSize',
});

export const TechDocsTabTextSize = techDocsTabTextSizePlugin.provide(
  createTechDocsAddonExtension({
    name: 'TechDocsTabTextSize',
    location: TechDocsAddonLocations.Content,
    component: TechDocsTabTextSizeContent,
  }),
);
